export default {
  wpSites: []
}
